import { render, staticRenderFns } from "./OrganizationMenu.vue?vue&type=template&id=297feeb4&scoped=true&"
import script from "./OrganizationMenu.vue?vue&type=script&lang=js&"
export * from "./OrganizationMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationMenu.vue?vue&type=style&index=0&id=297feeb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297feeb4",
  null
  
)

export default component.exports